<template>
    <div class="level pagination-form" v-if="count != 0">
        <template v-if="isLazy">
            <!--Pagination with show-more button-->
            <div class="w100" v-if="remainingCount > 0">
                <div class="d-flex h-center">
                    <button class="button is-cancel" @click.prevent="onShowMore">
                        <span class="icon" v-if="isLoading">
                            <loader text=" " />
                        </span>
                        <span> {{ $t('paginate.showMore') }} ({{ remainingCount }}) </span>
                    </button>
                </div>
            </div>
        </template>
        <template v-else>
            <!--Default pagination by page and per-page-->
            <div class="level-left">
                <template v-if="count > perPage">
                    <paginate
                        :page-count="Math.ceil(count / perPage)"
                        :click-handler="paginateChange"
                        :next-text="'&#8250;'"
                        :prev-text="'&#8249;'"
                        :force-page="currentPage"
                        :container-class="'paginate-class'"
                        v-model="currentPage" />
                </template>
            </div>
            <div class="control level-right" v-if="!hidePerPage">
                <div class="level-item">{{ $t('paginate.perPage') }}</div>
                <div class="select">
                    <b-select v-model="perPage" @input="onChangePerPage">
                        <option v-for="perPage in optionsPerPage" :key="perPage" :value="perPage">
                            {{ perPage }}
                        </option>
                    </b-select>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate';

export default {
    name: 'PaginationForm',
    components: {
        Paginate,
    },
    props: ['count', 'hidePerPage', 'value', 'isLazy', 'isLoading', 'iniPerPage'],
    data() {
        return {
            currentPage: 1,
            perPage: 15,
            optionsPerPage: [2, 5, 10, 15, 20, 50, 100, 200],
        };
    },
    computed: {
        remainingCount() {
            return this.count - this.perPage * this.currentPage;
        },
    },
    watch: {
        value: {
            handler: function (newValue, oldValue) {
                this.handleValue();
            },
            deep: true,
        },
    },
    created() {
        // this.$eventHub.$on("reloadContacts", this.fetchData);
        if (this.$eventHub) {
            this.$eventHub.$on('documents.deleted', this.handleDelete);
            this.$eventHub.$on('contacts.deleted', this.handleDelete);
            this.$eventHub.$on('contacts.created', this.handleCreate);
            this.$eventHub.$on('contacts.updated', this.handleUpdate);
        }
        this.handleValue();
    },
    beforeDestroy() {
        // this.$eventHub.$off("reloadContacts", this.fetchData);
        if (this.$eventHub) {
            this.$eventHub.$off('documents.deleted', this.handleDelete);
            this.$eventHub.$off('contacts.deleted', this.handleDelete);
            this.$eventHub.$off('contacts.created', this.handleCreate);
            this.$eventHub.$off('contacts.updated', this.handleUpdate);
        }
    },
    methods: {
        handleValue() {
            if (this.value?.perPage) {
                this.perPage = Number(this.value.perPage);
            } else if (this.iniPerPage) {
                this.perPage = this.iniPerPage;
            }
            if (this.value && Number(this.value.currentPage) >= 0) {
                this.currentPage = this.value.currentPage + 1;
            }
        },
        onChangePerPage(value) {
            this.paginateChange(1);
        },
        paginateChange(newPage) {
            this.currentPage = newPage;
            this.$emit('input', {
                keyname: this.value?.keyname,
                perPage: this.perPage,
                currentPage: this.currentPage - 1,
                isLazy: this.isLazy,
            });
        },
        handleDelete() {
            let pages = Math.floor((parseInt(this.count, 10) - 1) / this.perPage);
            let page = pages > this.currentPage ? pages : this.currentPage;
            this.paginateChange(page);
        },
        handleCreate() {
            let pages = Math.floor((parseInt(this.count, 10) + 1) / this.perPage);
            let page = pages < this.currentPage ? pages : this.currentPage;
            this.paginateChange(page);
        },
        handleUpdate() {
            let pages = Math.floor(parseInt(this.count, 10) / this.perPage);
            let page = pages < this.currentPage ? pages : this.currentPage;
            this.paginateChange(page);
        },
        onShowMore() {
            this.paginateChange(this.currentPage + 1);
        },
    },
    i18n: {
        messages: {
            en: {
                paginate: {
                    of: 'of',
                    page: 'Page',
                    perPage: 'Per page:',
                    showMore: 'Show more',
                },
            },
            fr: {
                paginate: {
                    of: 'de',
                    page: 'Page',
                    perPage: 'Par page:',
                    showMore: 'Afficher Plus',
                },
            },
            nl: {
                paginate: {
                    of: 'van',
                    page: 'Pagina',
                    perPage: 'Per pagina:',
                    showMore: 'Toon meer',
                },
            },
        },
    },
};
</script>

<style lang="scss">
/* paginate (bulma)
========================================================== */
.pagination-form {
    margin-top: 0.5rem;
    .control {
        font-size: 14px !important;
    }
}

html body .paginate-class {
    display: flex;
    list-style: none !important;
    margin: 0;
    padding: 0;
    li {
        padding: 0.35rem;
        border-radius: 0.25rem;
        a {
            color: var(--color-txt);
            padding: 0.25rem;
        }
        a:focus {
            outline: none;
        }
    }
    li:hover {
        color: #363636;
        background-color: #dbdbdb;
        a {
            font-weight: bold;
        }
    }
    li.active {
        background-color: var(--primary);
        a {
            font-weight: bold;
            color: white;
        }
    }
}
</style>
